import React from "react"

class CheckoutModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: this.props.title || "",
      message: this.props.message || "",
      loader: this.props.loader || false,
      url: this.props.url || "",
      urlText: this.props.urlText || "",
      success: this.props.success || false
    };
  }
  render() {
    var loader = this.state.loader === true ? <div className="loader">Loading...</div> : "";

    var url =
      this.state.url !== "" && this.state.urlText !== "" ? (
        <p>
          <a href={this.state.url}>{this.state.urlText}</a>
        </p>
      ) : (
        ""
      );

    var success = this.state.success === true ? <i className="icon-ok-sign" /> : "";

    return (
      <div className="checkout-modal">
        <div className="modal-content">
          <h1>{this.state.title}</h1>
          <p>{this.state.message}</p>
          {success}
          {url}
          {loader}
        </div>
      </div>
    );
  }
}

export default CheckoutModal;
